<script>
import toggleModal from '@/mixins/toggleModal';
import { mapActions } from 'vuex';
import UploadImages from '@/components/ux/upload/Upload-images.vue';
import createUploadFile from '@/utils/createUploadFile';
import bem from '@/utils/bem';

const b = bem('comparison-image-slider');
export default {
  components: { UploadImages },
  data() {
    return {
      isMultiple: false,
      beforeFileList: [],
      afterFileList: [],

      imageBeforeUri: '',
      imageAfterUri: '',
    };
  },
  props: {
  },
  mixins: [toggleModal],
  methods: {
    ...mapActions({
      addOrEditCategory: 'blogs/addOrEditCategory',
    }),
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    onCancel() {
      this.hideModal();
      this.$emit('update:comparisonImageSlider', {});
    },
    onSave() {
      this.hideModal();
      this.$emit('update:comparisonImageSlider', {
        imageBeforeUri: this.imageBeforeUri,
        imageAfterUri: this.imageAfterUri,
      });
    },
    async getUrl(uploadingFile, imageType) {
      const { url, file } = uploadingFile;
      let imageUrl = '';
      if (file) {
        const {
          data: {
            data: uploadedFile,
          },
        } = await createUploadFile(url, 'images-blog');
        imageUrl = uploadedFile.url;
      } else {
        imageUrl = url;
      }

      switch (imageType) {
        case 'before':
          this.imageBeforeUri = imageUrl;
          return null;
        case 'after':
          this.imageAfterUri = imageUrl;
          return null;
        default:
          return null;
      }
    },
  },
  watch: {
    beforeFileList(newValue) {
      if (newValue.length) {
        this.getUrl(newValue[0], 'before');
      } else {
        this.imageBeforeUri = '';
      }
    },
    afterFileList(newValue) {
      if (newValue.length) {
        this.getUrl(newValue[0], 'after');
      } else {
        this.imageAfterUri = '';
      }
    },
  },
};
</script>

<template>
  <a-modal :open="show" :footer="null" @cancel="onCancel" >
    <h1>
      Add Compare Image Slider
    </h1>
    <div :class="b('images-wrapper')">
      <div :class="b('image-block')">
        <h2>Image before:</h2>
        <UploadImages
          v-model:files="beforeFileList"
          :isMultiple="isMultiple"
          :classProps="b('uploader')"
        />
      </div>
      <div :class="b('image-block')">
        <h2>Image after:</h2>
        <UploadImages
          v-model:files="afterFileList"
          :isMultiple="isMultiple"
          :classProps="b('uploader')"
        />
      </div>
    </div>
    <div :class="b('buttons')" v-if="beforeFileList.length && afterFileList.length">
      <a-spin
        v-if="
          (beforeFileList.length && !imageBeforeUri)
          || (afterFileList.length && !imageAfterUri)
        "
        size="large"
      />
      <a-button
        v-if="imageBeforeUri && imageAfterUri"
        type="primary"
        :class="b('save-button')"
        @click="onSave"
      >
        Save
      </a-button>
    </div>
  </a-modal>
</template>

<style lang="scss">
.comparison-image-slider {

  &__images-wrapper {
    display: flex;
    gap: 20px;
    align-items: center;
    justify-content: space-evenly;
  }

  &__image-block {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__buttons {
    display: flex;
    margin-top: 20px;
    justify-content: flex-end;
    padding: 0 30px;
  }

  &__save-button {
    height: 40px;
    width: 120px;
    font-size: 20px;
  }

  &__uploader {
    .ant-upload-list-picture-card,
    .ant-upload-list-picture-select-card,
    .ant-upload-select,
    .ant-upload,
    .ant-upload-list-item-container {
      width: 200px !important;
      height: 200px !important;
    }
  }
}
</style>
